import { colorFor, handleFor } from '../../presence/identity';
import type { ChatMessage } from '../../store/types';

export interface Attribution {
  /** Display label: "You" (self), a peer's handle, "Viv" (assistant), or
   *  "Someone" (legacy/unattributed user message). Empty for system steps. */
  label: string;
  /** Identity color for the author dot; undefined for Viv/system. */
  color?: string;
  isSelf: boolean;
}

/**
 * Resolve how a chat message is attributed for the current viewer. Chat is one
 * shared transcript, so "You" is shown ONLY for the viewer's own authorSub;
 * everyone else is their handle + identity color. Assistant → Viv; system steps
 * are unattributed.
 */
export function attributionFor(msg: Pick<ChatMessage, 'role' | 'authorSub'>, selfSub: string | null): Attribution {
  if (msg.role === 'assistant') return { label: 'Viv', isSelf: false };
  if (msg.role === 'system') return { label: '', isSelf: false };
  // user
  if (!msg.authorSub) return { label: 'Someone', isSelf: false };
  if (selfSub && msg.authorSub === selfSub) {
    return { label: 'You', color: colorFor(msg.authorSub), isSelf: true };
  }
  return { label: handleFor(msg.authorSub), color: colorFor(msg.authorSub), isSelf: false };
}
